<template>
    <div class="container">
        <myheader name="解决方案"></myheader>
        <div class="banner minwidth ">
            <div class="banner-text">
                <div class="title">
                    <p>为不同角色, 提供量身定制的资产化解决方案</p>
                </div>
                <div class="sub">
                    <p>无论您是个人收藏家、全融机构、司法部门还是企业品牌</p>
                    <p>我们都能为您提供基于可信数据的专业服务，释放文化资产的全部潜力。</p>
                </div>
            </div>
        </div>
        <div class="mx1360 flex-c-c-c">
            <div class="list">
                <div class="list-li">
                    <el-row :type="colwrap?'':'flex'">
						<el-col :lg="12" :sm="24">
						    <div class="img-box">
						        <img class="ls-img" src="../../static/new/z-solution-img1.png" alt="">
						    </div>
						</el-col>
                        <el-col :lg="12" :sm="24">
                            <div class="info-box ">
								<img src="@/static/new/z-solution-icon1.png" class="icon1"/>
                                <div class="wt-ra">
									<div class="title">面向 个人藏家</div>
									<div class="sub-title">Facing individual collectors</div>
                                </div>
                                <div class="tt-box">
                                    <div class="tt-li align-c">
										<img  src="@/static/new/z-solution-1.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													用户痛点：
												</div>
											</div>
											<div class="tt-content">
												藏品真伪难辨、权属不清、传承困难、价值不明，无法有效转化为可流动的资产。
											</div>
										</div>
                                    </div>
									
									
									<div class="tt-li align-c">
										<img  src="@/static/new/z-solution-2.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													我们的方案：
												</div>
											</div>
											<div class="tt-content">
												提供从鉴证备案、区块链确权到科学估值的“一站式"服务，为您的每一件藏品生成唯一的“数字资产护照”。
											</div>
										</div>
									</div>
									
                                    <div class="tt-li align-c">
                                    	<img  src="@/static/new/z-solution-3.png" class="num"/>
                                    	<div class="k">
                                    		<div class="tt-title flex-r-s-c">
                                    			<div class="title-t">
                                    				核心价值：
                                    			</div>
                                    		</div>
                                    		<div class="tt-content">
                                    			让您的收藏清晰、可信、易于管理和传承，并在需要时轻松对接保险、信贷和交易市场。
                                    		</div>
                                    	</div>
                                    </div>
									
                                </div>
                                <div class="btn-box">
                                    <div @click="goPage('27')" class="btn-gr curadm">为我的藏品备案</div>
                                </div>
                            </div>
                        </el-col>
                        
                    </el-row>
                </div>
                <div class="list-li list-li2">
                    <el-row :type="colwrap?'':'flex'">
                        
                        <el-col :lg="12" :sm="24">
                            <div class="info-box ">
								<img src="@/static/new/z-solution-icon2.png" class="icon2"/>
                                <div class="wt-ra">
                                	<div class="title">面向 金融机构</div>
                                	<div class="sub-title">Facing financial institutions</div>
                                </div>
                                <div class="tt-box">
									
									<div class="tt-li align-c">
										<img  src="@/static/new/z-solution-1.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													用户痛点：
												</div>
											</div>
											<div class="tt-content">
												艺术品质押、保险、信托等业务中，标的物真伪难辨、估值主观、权属追踪困难，导致风控成本高、业务难以规模化。
											</div>
										</div>
									</div>
									
									
									<div class="tt-li align-c">
										<img  src="@/static/new/z-solution-2.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													我们的方案：
												</div>
											</div>
											<div class="tt-content">
												提供标准化的、基于可信数据的尽职调查与价值评估报告，并通过区块链技术实现质押物的权属清晰锁定与追踪。
											</div>
										</div>
									</div>
									
									<div class="tt-li align-c">
										<img  src="@/static/new/z-solution-3.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													核心价值：
												</div>
											</div>
											<div class="tt-content">
												显著降低艺术品金融业务的尽调成本和操作风险，为您拓展高净值客户资产配置服务提供可靠的技术支撑。
											</div>
										</div>
									</div>
								
                                </div>
                                <div class="btn-box">
                                    <div @click="goPage('28')" class="btn-gr curadm c2">联系机构合作</div>
                                </div>
                            </div>
                        </el-col>
						<el-col :lg="12" :sm="24">
						    <div class="img-box">
						        <img class="ls-img2" src="@/static/new/z-solution-img2.png" alt="">
						    </div>
						</el-col>
                    </el-row>
                </div>
               <!-- <div class="list-li list-li2">
                    <el-row :type="colwrap?'':'flex'">
                        <el-col :lg="12" :sm="24">
                            <div class="info-box ">
                                <div class="wt-ra flex-r-s-c">
                                    <div class="icon-box">
                                        <img class="icon-img" src="../../static/jjfa_icon_zfjg.png" alt="">
                                    </div>
                                    <div class="bl-t">
                                        面向
                                    </div>
                                    <div class="gr-t">
                                        司法与政府机构
                                    </div>
                                </div>
                                <div class="tt-box">
                                    <div class="tt-li">
                                        <div class="tt-title flex-r-s-c">
                                            <div class="num-box">
                                                <img class="num-img" src="../../static/jj_icon_1.png" alt="">
                                            </div>
                                            <div class="title-t">
                                                用户痛点：
                                            </div>
                                        </div>
                                        <div class="tt-content">
                                            在财产分割、遗产继承、海关查验、国有资产盘点等场景中，缺乏被广泛采信的艺术品鉴定与价值评估依据，导致执法与管理困难。
                                        </div>
                                    </div>
                                    <div class="tt-li">
                                        <div class="tt-title flex-r-s-c">
                                            <div class="num-box">
                                                <img class="num-img" src="../../static/jj_icon_2.png" alt="">
                                            </div>
                                            <div class="title-t">
                                                我们的方案：
                                            </div>
                                        </div>
                                        <div class="tt-content">
                                            提供具备司法采信潜力的第三方鉴定报告与价值评估公允意见，所有数据来源与评估流程均可溯源、可复核。
                                        </div>
                                    </div>
                                    <div class="tt-li">
                                        <div class="tt-title flex-r-s-c">
                                            <div class="num-box">
                                                <img class="num-img" src="../../static/jj_icon_3.png" alt="">
                                            </div>
                                            <div class="title-t">
                                                核心价值：
                                            </div>
                                        </div>
                                        <div class="tt-content">
                                            为司法判决和政府管理提供科学、中立、权威的技术支撑，提升执法效率与公信力，助力国有文化资产的数字化管理。
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-box">
                                    <div class="btn-gr curadm">申请查验服务</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :lg="12" :sm="24">
                            <div class="img-box">
                                <img class="ls-img" src="../../static/jjfa_adv_zfjg.png" alt="">
                            </div>
                        </el-col>
                    </el-row>
                </div> -->
                <div class="list-li list-li3">
                    <el-row :type="colwrap?'':'flex'">
                        <el-col :lg="12" :sm="24">
                            <div class="img-box">
                                <img class="ls-img3" src="@/static/new/z-solution-img3.png" alt="">
                            </div>
                        </el-col>
                        <el-col :lg="12" :sm="24">
                            <div class="info-box ">
								
								<img src="@/static/new/z-solution-icon3.png" class="icon3"/>
								<div class="wt-ra">
									<div class="title">面向 企业与品牌方</div>
									<div class="sub-title">Facing individual collectors</div>
								</div>
								
                                
                                <div class="tt-box">
									
									
									<div class="tt-li align-c">
										<img  src="@/static/new/z-solution-1.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													用户痛点：
												</div>
											</div>
											<div class="tt-content">
												希望通过艺术提升品牌形象，但难以找到合适的艺术家IP；企业收藏的艺术品作为资产难以盘点、管理和估值。
											</div>
										</div>
									</div>
									
									<div class="tt-li align-c">
										<img  src="@/static/new/z-solution-2.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													我们的方案：
												</div>
											</div>
											<div class="tt-content">
												提供基于"艺术家IP全景评估体系"的数据服务，助您发现最具合作潜力的艺术家；同时为您的企业收藏提供标准化的资产盘点、确权与动态
											</div>
										</div>
									</div>
									
									<div class="tt-li align-c">
										<img  src="@/static/new/z-solution-3.png" class="num"/>
										<div class="k">
											<div class="tt-title flex-r-s-c">
												<div class="title-t">
													核心价值：
												</div>
											</div>
											<div class="tt-content">
												让您的艺术合作与收藏决策更具数据支撑，提升品牌文化内涵，并实现企业文化资产的透明化、精细化管理。
											</div>
										</div>
									</div>
                                    
                                    
                                </div>
                                <div class="btn-box">
                                    <div @click="goPage('29')" class="btn-gr c3 curadm">探索艺术家IP库</div>
                                </div>
                            </div>
                        </el-col>
						
                    </el-row>
                </div>
            </div>

        </div>
        <myfooter></myfooter>

    </div>

</template>
<script>
import util from "@/common/util.js"
export default {
    name: "Solution",
    data() {
        return {

        }
    },
    methods:{
         goPage(id) {
            util.tourl("/detail", { id: id , lm:"解决方案" })
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../style.scss'; //所有页面公用
@import '../style2.scss'; //所有页面公用
@import './solution.scss';
</style>